import { useDispatch, useSelector } from "react-redux";
import {
  fileUploadAgree,
  fileUploadSet,
} from "../../../../modules/reducers/chat/agent/fileUpload";
import { useEffect, useRef, useState } from "react";
import { useGroupChannelContext } from "@sendbird/uikit-react/GroupChannel/context";
import useReactGASend from "#src/hooks/useReactGASend.js";

const useFileUpload = ({ ticketClose }) => {
  const { makeEventTrackFn } = useReactGASend();
  const dispatch = useDispatch();

  const agreement = useSelector((state) => state.fileUpload.agreement);

  const [fileModalIsOpen, setFileModalIsOpen] = useState(false);
  const { sendFileMessage } = useGroupChannelContext();
  const [selectedFile, setSelectedFile] = useState(null);
  const fileInputRef = useRef(null);

  const canFileSend = useSelector((state) => state.fileUpload.canFileSend);

  const openFileModal = () => {
    makeEventTrackFn({
      category: "event",
      action: "파일 업로드 버튼 클릭"
    });

    if (!agreement) {
      setFileModalIsOpen(true);
    } else {
      //파일 업로드
      openFileUploadwindow();
    }
  };

  const openFileUploadwindow = () => {
    if (fileInputRef.current) {
      if (ticketClose) {
        alert("상담이 종료되었습니다");
      } else {
        if (canFileSend) {
          fileInputRef.current.click();
        } else {
          alert(
            "본 업로드 버튼은 만료되었습니다. 상담원에게 새로운 버튼 요청을 해주세요"
          );
        }
      }
    }
  };

  const closeFileModal = () => {
    setFileModalIsOpen(false);
  };

  const onHandleAgree = (agree) => {
    dispatch(fileUploadAgree({ agreement: agree }));
    openFileUploadwindow();
  };

  const handleFileChange = async (event) => {
    const file = event.target.files?.[0];
    console.log("handleFileChange file", file);
    if (file) {
      const fileType = file.type.split("/")[0];
      const imageType = file.type.split("/")[1];
  
      console.log("handleFileChange fileType", fileType);
      if (fileType === "image") {
        if ((/(jpe?g|png)$/i).test(imageType)) {
          setSelectedFile(file);
          try {
            const response = await sendFileMessage({ file });
            console.log("sendFileMessage", response);
            if (response?.sendingStatus === "succeeded") {
              dispatch(fileUploadSet({ canFileSend: false }));
            } else {
              alert("이미지 업로드에 실패했습니다. 다시 시도하세요.");
            }
          } catch(error) {
            console.log("sendFileMessage", error);
            alert("이미지 업로드에 실패했습니다. 다시 시도하세요.");
          }
        } else {
          alert("jpeg, jpg, png 형식의 이미지만 업로드할 수 있습니다.");
        }
      } else {
        alert("이미지 파일만 업로드할 수 있습니다.");
      }
    }
  };

  return {
    onHandleAgree,
    fileModalIsOpen,
    openFileModal,
    closeFileModal,
    handleFileChange,
    fileInputRef,
  };
};

export default useFileUpload;
